import { formatToTitleCase } from './format-to-title-case';

import { Partner } from '@/types';

type Address = {
  addressLine1: string;
  number: string;
  addressLine2: string;
  city: string;
  state: string;
  zipcode: string;
  neighborhood: string;
  type?: string;
};

export const formatPartnerAddress = (address: Address): string => {
  const addressLine1 = formatToTitleCase(address.addressLine1 ?? '');
  const addressNumber = address.number ?? '';
  const addressLine2 = formatToTitleCase(address.addressLine2 ?? '');
  const neighborhood = formatToTitleCase(address.neighborhood ?? '');

  const baseAddressParts: string[] = [];
  if (addressLine1) {
    baseAddressParts.push(addressLine1);
  }
  if (addressNumber) {
    baseAddressParts.push(addressNumber);
  }
  if (addressLine2) {
    baseAddressParts.push(addressLine2);
  }

  const baseAddress = baseAddressParts.join(', ');
  const neighborhoodPart = neighborhood ? ` - ${neighborhood}` : '';
  const fullBaseAddress = `${baseAddress}${neighborhoodPart}`;

  const rawZipcode = address.zipcode ?? '';
  let formattedZipcode = rawZipcode;

  if (address.type !== 'branch' && rawZipcode.length === 8) {
    formattedZipcode = `${rawZipcode.slice(0, 5)}-${rawZipcode.slice(5)}`;
  }

  const cityState = `${formatToTitleCase(address.city ?? '')} - ${address.state ?? ''} ${formattedZipcode !== '' ? `, ${formattedZipcode}` : ''}`.trim();

  if (!fullBaseAddress) {
    return cityState;
  }

  const fullAddress = `${fullBaseAddress}, ${cityState}`;

  return fullAddress;
};

export const formatPartnerName = (partner: Partner): string => {
  if (partner.facility.name) {
    return `${formatToTitleCase(partner.socialName)} - ${formatToTitleCase(partner.facility.name)}`;
  }

  return `${formatToTitleCase(partner.socialName)}`;
};
